import { ReactSVG } from 'react-svg';
import { Button, ButtonsContainer } from '@forma/forma-ui-kit';
import PageBlock from '@/components/PageBlock';
import Link from '@/components/Link';

import styles from './widgets-banner.module.css';

const WidgetsBanner = () => {
  return (
    <PageBlock
      title="Подключайте готовые виджеты, чтобы решать ещё больше бизнес-задач в DataDoc"
      titleClassName={styles.title}
      className={styles.root}
    >
      <div className={styles.items}>
        {Array.from(new Array(11), (el, index) => (
          <div key={index} className={styles.item}>
            <img
              className={styles.icon}
              src={`/icons/widgets/Slot-${index + 1}.webp`}
              alt={`Виджет Slot-${index + 1}`}
            />
          </div>
        ))}
      </div>
      <ButtonsContainer className={styles.buttons}>
        <Button
          as={Link}
          viewStyle="secondary"
          size="m"
          icon={<ReactSVG src="/icons/chevron-right-small.svg" wrapper="span" />}
          href="/marketplace"
          reversed
        >
          Смотреть виджеты
        </Button>
      </ButtonsContainer>
    </PageBlock>
  );
};

export default WidgetsBanner;
